CCL.sortingCategory = {
  autoload: [
    // ['sorting', $('.sorting').length > 0],
    ['selectableDropdown', $('.sortby').length > 0]
  ],

  // sorting() {
  //   let que = '';
  //   $('.sorting').change((event) => {
  //     que = '';
  //     if ($.query.get('page')) {
  //       $.query.REMOVE('page');
  //     }
  //     if ($.query.get('page')) {
  //       que = $.query.set('sort', $('.sorting option:selected').val());
  //     } else {
  //       que = $.query.set('sort', $('.sorting option:selected').val()).set('q', $(event.target).data('defaultsort'));
  //     }
  //     document.location.search = que;
  //   });
  // },
  selectableDropdown() {
    $('.sortby .selected-item').click((e) => {
      $('#sorting')[0].innerText = e.currentTarget.innerText;
      $('.dropdown-menu button').removeClass('active');
      e.currentTarget.className += ' active'; // Append active class to selected

      const cuurentValue = $(e.currentTarget).data('query').trim();
      const selectedBtnValue = $(e.currentTarget).attr('value');
      let que = '';
      if ($.query.get('page')) {
        $.query.REMOVE('page');
      }
      if ($.query.get('page')) {
        que = $.query.set('sort', selectedBtnValue);
      } else {
        que = $.query.set('sort', selectedBtnValue).set('q', cuurentValue);
      }
      // $.query.set('q', $(e.target).data('query'));
      document.location.search = que;
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/components/c-sorting-category/sorting-category.js